import { render, staticRenderFns } from "./InventorySettingsComponent.vue?vue&type=template&id=b0a6338e&"
import script from "./InventorySettingsComponent.vue?vue&type=script&lang=js&"
export * from "./InventorySettingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports